"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const metrics = [{
  value: 450,
  suffix: "+",
  unitLabel: "HOURS SAVED / MONTH"
}, {
  value: 65,
  suffix: "%",
  unitLabel: "OPERATIONAL COST REDUCTION"
}, {
  value: 12,
  suffix: "x",
  unitLabel: "FASTER RESPONSE TIMES"
}, {
  value: 98,
  suffix: "%",
  unitLabel: "AUTOMATION ACCURACY RATE"
}];
function CountUp({
  end,
  suffix,
  start,
  duration = 1200
}: {
  end: number;
  suffix: string;
  start: boolean;
  duration?: number;
}) {
  const [count, setCount] = useState(0);
  const rafRef = useRef<number | null>(null);
  useEffect(() => {
    if (!start) return;
    const startTime = performance.now();
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * end));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setCount(end);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    };
  }, [start, end, duration]);
  return <span>
      {count}
      {suffix}
    </span>;
}
export default function Impact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.25
  });
  return <section data-section-id="2477" id="impact-in-numbers" className="bg-background text-foreground">
      <div className="bg-foreground text-background py-40 px-6 md:px-12 lg:px-20" ref={ref}>
        <div className="max-w-[1400px] mx-auto">
          {}
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 md:gap-16 pb-20 md:pb-28">
            <div className="font-mono text-xs uppercase tracking-widest text-background/90 shrink-0" style={{
            letterSpacing: "0.15em"
          }}>
              § 03 / Impact Metrics
            </div>
            <div className="md:max-w-xl">
              <p className="font-default text-2xl md:text-3xl font-medium leading-tight tracking-tight text-background">
                Data-driven <span className="font-mono text-background/70">autonomy</span> that scales your business operations.
              </p>
            </div>
          </div>

          {}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative">
            {metrics.map((metric, i) => <div data-index={i} key={i} className={`flex flex-col py-10 md:py-0 md:px-8 lg:px-10 first:md:pl-0 last:md:pr-0 relative ${i !== 0 ? "border-t md:border-t-0 md:border-l border-background/20 lg:border-background/20" : ""}`} style={{
            borderColor: i !== 0 ? "var(--background)" : undefined
          }}>
                <div className="font-default font-black leading-[0.9] tracking-tight text-background" style={{
              fontSize: "clamp(4rem, 8vw, 7rem)",
              fontWeight: 900
            }}>
                  <CountUp end={metric.value} suffix={metric.suffix} start={isVisible} />
                </div>
                <div className="h-px w-full bg-background/20 mt-6 mb-4" />
                <div className="font-mono text-[0.7rem] md:text-xs uppercase text-background/80" style={{
              letterSpacing: "0.15em"
            }}>
                  {metric.unitLabel}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}